import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ma-2 ma-sm-5 ma-md-10" },
    [
      _c(
        VSheet,
        [
          _c(VSelect, {
            attrs: { label: "Chart type", items: _vm.chartTypes },
            model: {
              value: _vm.chartType,
              callback: function ($$v) {
                _vm.chartType = $$v
              },
              expression: "chartType",
            },
          }),
          _c(VSelect, {
            attrs: { label: "Choose a display unit", items: _vm.units },
            on: {
              change: function ($event) {
                _vm.data = _vm.prepChartData()
              },
            },
            model: {
              value: _vm.selectedUnit,
              callback: function ($$v) {
                _vm.selectedUnit = $$v
              },
              expression: "selectedUnit",
            },
          }),
        ],
        1
      ),
      _c(
        VSheet,
        { staticClass: "d-flex justify-center" },
        [
          _vm.data
            ? _c(_vm.chartType, {
                ref: "chartRef",
                tag: "component",
                attrs: {
                  data: _vm.data,
                  options: _vm.options,
                  responsive: true,
                  maintainAspectRatio: false,
                  width: _vm.width / 1.5,
                  height: 400,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(VSheet, { staticClass: "d-flex justify-center ma-5" }, [
        _c(
          "a",
          {
            attrs: {
              href: _vm.image64Url,
              target: "_blank",
              download: `${_vm.product.name}_chart.png`,
            },
          },
          [_vm._v(" Save Chart ")]
        ),
      ]),
      _c(VDivider),
      _vm.parentProduct
        ? _c("div", { staticClass: "my-2" }, [
            _c("b", [_vm._v(_vm._s(_vm.product.name))]),
            _vm._v(" belongs to "),
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    return _vm.changeProduct(_vm.parentProduct)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.parentProduct.name))]
            ),
          ])
        : _vm._e(),
      _vm.product && _vm.product.hasChildren
        ? _c(
            "div",
            [
              _c("b", [_vm._v(_vm._s(_vm.product.name))]),
              _vm._v(" includes the following products: "),
              _vm._l(_vm.products, function (product) {
                return [
                  !product.hasChildren
                    ? _c("div", { key: product.id, staticClass: "ml-4 my-2" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                return _vm.changeProduct(product)
                              },
                            },
                          },
                          [_vm._v(_vm._s(product.name))]
                        ),
                      ])
                    : _vm._e(),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }